import { memo, ReactNode } from 'react'
import { Paper, Title, Text, Button, Stack } from 'components'

interface SelectionCardProps {
  title: string
  description: string
  buttonText: string
  buttonIcon: ReactNode
  onClick: () => void
}

export const SelectionCard = memo<SelectionCardProps>(({
  title,
  description,
  buttonText,
  buttonIcon,
  onClick
}) => {
  return (
    <Paper
      p="xl"
      radius="md"
      shadow="sm"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: 180,
      }}
    >
      <Stack spacing="md" sx={{ flex: 1 }}>
        <Title order={3} weight={600}>{title}</Title>
        <Text size="md" sx={{ flex: 1 }}>
          {description}
        </Text>
        <Button
          leftIcon={buttonIcon}
          color="turquoise"
          size="md"
          onClick={onClick}
          sx={{ alignSelf: 'flex-start' }}
        >
          {buttonText}
        </Button>
      </Stack>
    </Paper>
  )
})

SelectionCard.displayName = 'SelectionCard'
